"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: styles
  }, /*#__PURE__*/_react.default.createElement("circle", {
    opacity: "0.8",
    cx: "50",
    cy: "50",
    r: "50",
    fill: "#A6D4FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7497 39.6667H35.4997V44.5833H33.083C29.0789 44.5833 25.833 49.1144 25.833 53.1875C25.833 57.2606 29.0789 61.7917 33.083 61.7917H41.2127C44.4559 64.8405 48.8221 66.7083 53.6247 66.7083C63.6348 66.7083 71.7497 58.5935 71.7497 48.5833V39.6667ZM37.5032 56.875C36.3544 54.6459 35.6543 52.1477 35.5225 49.5H33.083C31.7483 49.5 30.6663 51.8298 30.6663 53.1875C30.6663 54.5452 31.7483 56.875 33.083 56.875H37.5032Z",
    fill: "#091E42"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "35.5",
    y: "71.625",
    width: "36.25",
    height: "4.91666",
    rx: "1",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.3",
    d: "M40.6134 20L43.4106 22.8337C41.3433 24.9454 41.3502 28.3621 43.4262 30.4651C43.6039 30.6452 43.794 30.8122 43.9951 30.9649L45.167 31.8553L42.8047 35.0727L41.6328 34.1823C41.2822 33.9159 40.9506 33.6246 40.6406 33.3105C37.0198 29.6425 37.0076 23.6832 40.6134 20Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.3",
    d: "M52.6964 22.4583L55.4936 25.292C53.4263 27.4037 53.4332 30.8204 55.5092 32.9234C55.687 33.1035 55.8771 33.2705 56.0781 33.4232L57.25 34.3136L54.8877 37.531L53.7158 36.6406C53.3652 36.3743 53.0336 36.0829 52.7236 35.7688C49.1028 32.1009 49.0906 26.1415 52.6964 22.4583Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.3",
    d: "M64.7794 20L67.5766 22.8337C65.5093 24.9454 65.5163 28.3621 67.5922 30.4651C67.77 30.6452 67.9601 30.8122 68.1611 30.9649L69.333 31.8553L66.9707 35.0727L65.7988 34.1823C65.4482 33.9159 65.1166 33.6246 64.8066 33.3105C61.1858 29.6425 61.1736 23.6832 64.7794 20Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "71",
    cy: "37",
    r: "10",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "70",
    y: "32",
    width: "2",
    height: "7",
    rx: "1",
    fill: "#E01E5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "70",
    y: "40",
    width: "2",
    height: "2",
    rx: "1",
    fill: "#E01E5A"
  }));
}

var _default = Svg;
exports.default = _default;